import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

const baseDividerClasses = cn(`
  border-t border-b-0 border-border-default bg-border-default
  legacy:border-legacy-brand-border legacy:bg-legacy-brand-border
`);

export const Divider: FC<
  ComponentPropsWithoutRef<'hr'> & { direction?: 'horizontal' | 'vertical' }
> = ({ direction = 'horizontal', ...props }) => {
  if (direction === 'vertical') {
    return (
      <div
        {...props}
        data-testid="divider-vertical"
        aria-hidden="true"
        className={cn(
          baseDividerClasses,
          `h-full w-px select-none`,
          props.className
        )}
      />
    );
  }

  return (
    <hr
      {...props}
      data-testid="divider-horizontal"
      className={cn(
        baseDividerClasses,
        `
          mx-0 my-md w-full
          legacy:my-[0.75rem]
        `,
        props.className
      )}
    />
  );
};

/** @deprecated Use `<Divider direction="vertical" />` instead. */
export const VerticalDivider: FC<ComponentPropsWithoutRef<'div'>> = (props) => (
  <Divider direction="vertical" {...props} />
);

export const CardDivider: FC<ComponentPropsWithoutRef<'hr'>> = (props) => (
  <Divider
    {...props}
    className={cn(
      baseDividerClasses,
      `-mx-xl w-[calc(100%+var(--spacing-xl)*2)]`,
      `legacy:mx-[-1.5rem] legacy:w-[calc(100%+3rem)]`,
      props.className
    )}
  />
);
